import React from 'react';

import { Link } from 'layout/Header/style';

const NavLinks = [{
  name: 'Maps',
  path: '/maps/',
}, {
  name: 'Datasets',
  path: '/datasets/',
}];

const PagesNavigation = () => (
  NavLinks.map(({ name, path }) => (
    <Link activeClassName="active" key={name} to={path}>{name}</Link>
  )));

export default PagesNavigation;
